import { scpConfigService } from "../services/scpConfigService";

import { show as showAlert } from "../../Notifications/actions/alert.actions";

import { message } from "../../../constants/app.constants";

import {
  scpIssuerConstants,
  nameSpace
} from "../constants/scpIssuerConfig.constants";

///============Get SCP configuration DATA===============///
export const getIssuerConfig = issuerCode => {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await scpConfigService.getAllScpIssuersConfigs({
        issuerCode: issuerCode.issuerCode
      });
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        showAlert(
          "danger",
          "Failed to get selected configuration",
          error ? error.message : message.GENERIC_ERROR
        )
      );
    }
  };
  function request(request) {
    return { type: scpIssuerConstants[`GET_${nameSpace}_REQUEST`], request };
  }
  function success(response) {
    return {
      type: scpIssuerConstants[`GET_${nameSpace}_SUCCESS`],
      response
    };
  }
  function failure(error) {
    return { type: scpIssuerConstants[`GET_${nameSpace}_FAILURE`], error };
  }
};

export const resetSCPConfigs = () => {
  return { type: scpIssuerConstants[`GET_${nameSpace}_RESET`] };
}